export default __webpack_public_path__ + "static/media/next.ce3f19ff.svg";